import { CardWithC4CssProps } from './CssConfig';

export const pipelineConfigs = [
  {
    componentReference: 'title',
    label: 'Pipeline history',
    id: 'pipelines-holder',
    cssProps: {
      width: '100%',
      display: 'block',
    },
    count: 6,
  },
  // cards
  {
    componentReference: 'container',
    id: 'pipelines-cards-container',
    children: [
      {
        containerType: 'pipeline',
        componentType: 'card',
        componentReference: 'card',
        id: 'pipeline_applied',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'applied',
          id: 'applied',
          value: 400,
          topLabel: 'Application review stages',
          bottomLabel: 'APPLICANTS',
          // hoverLabel: 'Total number of applications received from candidates',
          // tag: 'Based on tag data',
        },
        api: {
          subject_type: 'pipeline',
          metadata: {
            tileKey: 'pipeline_applied',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'applied',
            id: 'pipeline_applied',
          },
        },
      },
      {
        containerType: 'pipeline',
        componentType: 'card',
        componentReference: 'card',
        id: 'pipeline_interviewed',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'interviewed',
          id: 'interviewed',
          value: 350,
          // compareValue: 63,
          // percentageDiff: 75,
          // trend: 'up',
          // comparisonLabel: 'vs previous 8 days',
          topLabel: 'Interview stages',
          bottomLabel: 'APPLICANTS',
          // hoverLabel: 'Total number of interviews conducted with candidates',
          // tag: 'Based on tag data',
        },
        api: {
          subject_type: 'pipeline',
          metadata: {
            tileKey: 'pipeline_interviewed',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'interviewed',
            id: 'pipeline_interviewed',
          },
        },
      },
      {
        containerType: 'pipeline',
        componentType: 'card',
        componentReference: 'card',
        id: 'pipeline_offer',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'offer',
          id: 'offer',
          value: 220,
          topLabel: 'Offer stages',
          bottomLabel: 'APPLICANTS',
          // hoverLabel: 'Total number of job offers issued to candidates',
          // tag: 'Based on tag data',
        },
        api: {
          subject_type: 'pipeline',
          metadata: {
            tileKey: 'pipeline_offer',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'offer',
            id: 'pipeline_offer',
          },
        },
      },
      {
        containerType: 'pipeline',
        componentType: 'card',
        componentReference: 'card',
        id: 'pipeline_hired',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'hired',
          id: 'hired',
          value: 55,
          // compareValue: 5,
          // percentageDiff: 100,
          // trend: 'down',
          // comparisonLabel: 'vs previous 8 days',
          topLabel: 'Hired stages',
          bottomLabel: 'APPLICANTS',
          // hoverLabel: 'Total number of candidates hired from the pool',
          // tag: 'Based on tag data',
        },
        api: {
          subject_type: 'pipeline',
          metadata: {
            tileKey: 'pipeline_hired',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'hired',
            id: 'pipeline_hired',
          },
        },
      },
    ],
  },

  // chart
  {
    containerType: 'pipeline',
    componentType: 'chart',
    componentReference: 'chart',
    id: 'pipeline_chart',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Pipeline history',
      id: 'pipeline_chart',
      chartData: {
        categories: ['Application review', 'Interviews', 'Offer', 'Hired'],
        series: [
          {
            name: 'Application Review',
            y: 1387,
          },
          {
            name: 'Interviews',
            y: 624,
          },
          {
            name: 'Offer',
            y: 222,
          },
          {
            name: 'Hired',
            y: 53,
          },
        ],
      },
      chartType: 'pyramid',
    },
    api: {
      subject_type: 'pipeline',
      metadata: {
        tileKey: 'pipeline_chart',
        componentType: 'chart',
        apiParam: 'chart_table',
        headerKeys: [
          'application_review_total_count',
          'interviews_total_count',
          'offer_total_count',
          'hired_total_count',
        ],
        id: 'pipeline_chart',
      },
    },
  },

  // table
  {
    containerType: 'pipeline',
    componentType: 'table',
    componentReference: 'table',
    id: 'pipeline_table',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Pipeline history',
      id: 'pipeline_table',
      tableData: [
        {
          ds: '0',
          dt: '2023-Q4',
          header: '2023-Q4',
          g1: null,
          g2: null,
          time_in_application_review: 0,
          time_in_interviews: 0,
          time_in_offer: 0,
          time_in_hired: 0,
          time_in_rejected: 0,
          application_review_total_count: 0,
          interviews_total_count: 0,
          offer_total_count: 0,
          hired_total_count: 0,
          rejected_total_count: 0,
          application_review_actual_count: 0,
          interviews_actual_count: 0,
          offer_actual_count: 0,
          hired_actual_count: 0,
          rejected_actual_count: 0,
          application_review_total_count_total: 1421,
          application_review_total_count_per: 0,
          interviews_total_count_total: 651,
          interviews_total_count_total_per: 0,
          offer_total_count_total: 225,
          offer_total_count_per: 0,
          hired_total_count_total: 54,
          hired_total_count_per: 0,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q1',
          header: '2024-Q1',
          g1: null,
          g2: null,
          time_in_application_review: 0,
          time_in_interviews: 0,
          time_in_offer: 0,
          time_in_hired: 0,
          time_in_rejected: 0,
          application_review_total_count: 0,
          interviews_total_count: 0,
          offer_total_count: 0,
          hired_total_count: 0,
          rejected_total_count: 0,
          application_review_actual_count: 0,
          interviews_actual_count: 0,
          offer_actual_count: 0,
          hired_actual_count: 0,
          rejected_actual_count: 0,
          application_review_total_count_total: 1421,
          application_review_total_count_per: 0,
          interviews_total_count_total: 651,
          interviews_total_count_total_per: 0,
          offer_total_count_total: 225,
          offer_total_count_per: 0,
          hired_total_count_total: 54,
          hired_total_count_per: 0,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q2',
          header: '2024-Q2',
          g1: null,
          g2: null,
          time_in_application_review: 25043538,
          time_in_interviews: 86845123,
          time_in_offer: 4654413,
          time_in_hired: 369004,
          time_in_rejected: 0,
          application_review_total_count: 111,
          interviews_total_count: 75,
          offer_total_count: 29,
          hired_total_count: 7,
          rejected_total_count: 0,
          application_review_actual_count: 76,
          interviews_actual_count: 72,
          offer_actual_count: 25,
          hired_actual_count: 7,
          rejected_actual_count: 0,
          application_review_total_count_total: 1421,
          application_review_total_count_per: '7.8',
          interviews_total_count_total: 651,
          interviews_total_count_total_per: '11.5',
          offer_total_count_total: 225,
          offer_total_count_per: '12.9',
          hired_total_count_total: 54,
          hired_total_count_per: '13.0',
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q3',
          header: '2024-Q3',
          g1: null,
          g2: null,
          time_in_application_review: 168857899,
          time_in_interviews: 86283705,
          time_in_offer: 17013588,
          time_in_hired: 1475988,
          time_in_rejected: 0,
          application_review_total_count: 866,
          interviews_total_count: 408,
          offer_total_count: 138,
          hired_total_count: 31,
          rejected_total_count: 0,
          application_review_actual_count: 706,
          interviews_actual_count: 324,
          offer_actual_count: 117,
          hired_actual_count: 31,
          rejected_actual_count: 0,
          application_review_total_count_total: 1421,
          application_review_total_count_per: '60.9',
          interviews_total_count_total: 651,
          interviews_total_count_total_per: '62.7',
          offer_total_count_total: 225,
          offer_total_count_per: '61.3',
          hired_total_count_total: 54,
          hired_total_count_per: '57.4',
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q4',
          header: '2024-Q4',
          g1: null,
          g2: null,
          time_in_application_review: 24750108,
          time_in_interviews: 6715105,
          time_in_offer: 4729548,
          time_in_hired: 851218,
          time_in_rejected: 0,
          application_review_total_count: 444,
          interviews_total_count: 168,
          offer_total_count: 58,
          hired_total_count: 16,
          rejected_total_count: 0,
          application_review_actual_count: 368,
          interviews_actual_count: 134,
          offer_actual_count: 44,
          hired_actual_count: 16,
          rejected_actual_count: 0,
          application_review_total_count_total: 1421,
          application_review_total_count_per: '31.2',
          interviews_total_count_total: 651,
          interviews_total_count_total_per: '25.8',
          offer_total_count_total: 225,
          offer_total_count_per: '25.8',
          hired_total_count_total: 54,
          hired_total_count_per: '29.6',
          subRows: [],
        },
      ],
      metric: 'passthrough_rate',
    },
    api: {
      subject_type: 'pipeline',
      metadata: {
        tileKey: 'pipeline_table',
        componentType: 'table',
        apiParam: 'chart_table',
        filters: {
          group_by_1: { id: null, label: 'Time', key: 'dt' },
          group_by_2: { id: null, label: 'None' },
          metrics: { id: 'passthrough_rate', label: 'Passthrough rate' },
        },
        headerKeys: [
          'application_review_total_count',
          'interviews_total_count',
          'offer_total_count',
          'hired_total_count',
        ],
        id: 'pipeline_table',
      },
    },
  },
];

export const pipelineLayoutConfig = [
  {
    key: 'pipeline_applied',
    x: 0,
    y: 0,
    w: 3,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'pipeline_interviewed',
    x: 3,
    y: 0,
    w: 3,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'pipeline_offer',
    x: 6,
    y: 0,
    w: 3,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'pipeline_hired',
    x: 9,
    y: 0,
    w: 3,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'pipeline_chart',
    x: 0,
    y: 7,
    w: 12,
    h: 21,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'pipeline_table',
    x: 0,
    y: 28,
    w: 12,
    h: 18,
    minW: 8,
    minH: 8,
    maxW: 12,
    maxH: 100,
  },
];
